import { render, staticRenderFns } from "./PriceFilter.vue?vue&type=template&id=fd938af0&"
import script from "./PriceFilter.vue?vue&type=script&lang=js&"
export * from "./PriceFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports